// extracted by mini-css-extract-plugin
module.exports = {"root":"ColumnAccessor_root__3RxRs","cell":"ColumnAccessor_cell__3fZ_D","firstCellAccent":"ColumnAccessor_firstCellAccent__1MLC3"};